export default "__VITE_ASSET__a3de9635__"